const ActionTypes = {
  UPDATE_CART : "UPDATE_CART", 
  UPDATE_USER_DATA : "UPDATE_USER_DATA", 
  UPDATE_PRODUCT_DATA : "UPDATE_PRODUCT_DATA", 
  DELETE_PRODUCT_DATA : "DELETE_PRODUCT_DATA", 
}

export default ActionTypes


// WEBPACK FOOTER //
// ./src/app/catalogo/actions/ActionTypes.js